import PageBanner from "../components/PageBanner";
import SEO from "../lib/SEO";
import { useSettings } from "../lib/SettingsContext";

export default function About() {
    const { settings } = useSettings();
    return (
        <main data-testid="about-page">
            <SEO title="About Us — Cake Central" description="Meet Cake Central — Sydney's bespoke cake studio." path="/about" />
            <PageBanner
                eyebrow="Our Story"
                title="About Cake Central"
                image={settings?.banner_about || "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"}
            />
            <section className="bg-[#FFF7FB] py-16 md:py-24">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid md:grid-cols-2 gap-12 items-start">
                        <div>
                            <p className="text-xs tracking-[0.3em] uppercase text-ink-soft mb-4">Sydney · Est. 2019</p>
                            <h2 className="font-display text-3xl md:text-4xl leading-tight mb-6">
                                A studio built on <span className="italic">care</span>, craft and curiosity.
                            </h2>
                        </div>
                        <div className="text-ink-soft leading-relaxed space-y-4">
                            <p>{settings.about_short}</p>
                            <p>
                                Every cake we make is built around the people it celebrates. We start with a
                                conversation — about flavours you love, the feeling of the day, the textures and
                                details that matter. From there we sketch, taste, refine, and bake.
                            </p>
                            <p>
                                {settings.about_long ||
                                    "Whether it's a quiet first birthday, a grand wedding, or an intimate engagement, Cake Central exists to give those moments a centrepiece worth remembering."}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-white border-t border-[#EAE3DE] py-16 md:py-20">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-3 gap-10 text-center">
                    {[
                        { n: "500+", l: "Cakes delivered" },
                        { n: "100%", l: "Custom designs" },
                        { n: "Sydney", l: "Wide delivery" },
                    ].map((v) => (
                        <div key={v.l}>
                            <p className="font-display text-4xl md:text-5xl text-blush mb-2">{v.n}</p>
                            <p className="text-xs tracking-[0.3em] uppercase text-ink-soft">{v.l}</p>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    );
}
